/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\CarousselStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Thursday, February 16th 2023, 10:17:13 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from 'Utils/ThemeColor';
import { Carousel } from 'react-responsive-carousel';
import styled from "styled-components";

const CarousselStyled = styled(Carousel).attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
min-width: 100%;
max-width: 100%;
border-bottom-left-radius: 0.5rem;
border-bottom-right-radius: 0.5rem;

.thumb:hover {
    border-color: ${(props: any) => getThemeColor(props.bgColor)};
    }
.thumb.selected {
    border-color: ${(props: any) => getThemeColor(props.bgColor)};
}
.carousel-status{
    display: none;
}
`;

export default CarousselStyled;
